import { Customer } from 'types/Customer';

function getName(customer: Customer) {
  return customer.companyName || `${customer.firstName} ${customer.lastName}`;
}

const captionOptions: ((customer: Customer) => string)[] = [
  (customer: Customer) => getName(customer),
  (customer: Customer) => `${getName(customer)} (email: ${customer.email})`,
  (customer: Customer) => `${getName(customer)} (phone: ${customer.phone})`,
  (customer: Customer) => `${getName(customer)} (id: ${customer.customerID})`,
];

export function getUniqueCaptionForCustomerInList(
  customer: Customer,
  _index: number,
  array: Customer[],
) {
  const uniqueCaption = captionOptions.find(caption => {
    const candidate = caption(customer);
    if (candidate === '') {
      return false; // Empty captions are not acceptable
    }
    if (
      array.some(
        otherCustomer =>
          customer !== otherCustomer && caption(otherCustomer) === candidate,
      )
    ) {
      return false; // Some other customer would get the same caption, try again
    }
    return true;
  });

  if (!uniqueCaption) {
    console.warn(
      'Out of all the captioning options, none of them are unique to this customer',
      { customer, array },
    );
    return getName(customer);
  }

  return uniqueCaption(customer);
}
